"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastingFormFieldTypeEnum = void 0;
exports.CastingFormFieldFromJSON = CastingFormFieldFromJSON;
exports.CastingFormFieldFromJSONTyped = CastingFormFieldFromJSONTyped;
exports.CastingFormFieldToJSON = CastingFormFieldToJSON;
exports.CastingFormFieldToJSONTyped = CastingFormFieldToJSONTyped;
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var CastingFormFieldTypeEnum;
(function (CastingFormFieldTypeEnum) {
    CastingFormFieldTypeEnum["Checkbox"] = "checkbox";
    CastingFormFieldTypeEnum["File"] = "file";
    CastingFormFieldTypeEnum["Text"] = "text";
    CastingFormFieldTypeEnum["Textarea"] = "textarea";
    CastingFormFieldTypeEnum["Select"] = "select";
})(CastingFormFieldTypeEnum || (exports.CastingFormFieldTypeEnum = CastingFormFieldTypeEnum = {}));
function CastingFormFieldFromJSON(json) {
    return CastingFormFieldFromJSONTyped(json, false);
}
function CastingFormFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'attributes': !(0, runtime_1.exists)(json, 'attributes') ? undefined : json['attributes'],
        'label': json['label'],
        'name': json['name'],
        'type': json['type'],
        'placeholder': !(0, runtime_1.exists)(json, 'placeholder') ? undefined : json['placeholder'],
        'defaultValue': json['defaultValue'],
    };
}
function CastingFormFieldToJSON(value) {
    return CastingFormFieldToJSONTyped(value, false);
}
function CastingFormFieldToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'attributes': value.attributes,
        'label': value.label,
        'name': value.name,
        'type': value.type,
        'placeholder': value.placeholder,
        'defaultValue': value.defaultValue,
    };
}
